module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAjCAYAAAD17ghaAAAAAXNSR0IArs4c6QAAATNJREFUWAntWEGqwjAQNcFLCB7DreDWg9Se4G8UXYkbvUDtQf5WcNtjfPACrlykvhc6EqJCqSnyYQamk6bJe5PXtDAxg8bKspw6535wO4GPpD9xvACvstbusyw7E9vwAvJlXddbuL9nX8/mkMQaSexMs/ITCG3PpDE8k5gNG9k9uTHmF75AZn/x6KIoaunL87yTUljsGCof4XNgWXKTmO/c2ztyef5p5MLIEeBMmMBjw71aeTA4STPiGHnpkyB3BNEEVIH/owC+3xs3usSOm/5pWmsF8Pc6YPa1iU9AXTuGbSfi97vCWHpSa61AUtYATBNQBVQBVUAVUAVUASrAitUbSydp9xUjjgsTqISMdVs0QB4liVIbBmDV16tji1qNBwUbuAsy67sp5wPnR5kNeb5yQnIHRLh0UMrQfZwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/icon/footer-new-word-inactive.png
// module id = MDP5
// module chunks = 1